export default "__VITE_ASSET__8374f0d8__"